var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_58660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2623 8.26953H31.7962V10.4026H34.9957V33.8659H5.1333V10.4026H8.33284V8.26953H4.86667C4.61736 8.2737 4.37131 8.32694 4.14258 8.42621C3.91385 8.52548 3.70691 8.66884 3.5336 8.8481C3.36028 9.02737 3.22397 9.23901 3.13246 9.47096C3.04096 9.70291 2.99604 9.95061 3.00027 10.1999V34.0685C2.99604 34.3178 3.04096 34.5655 3.13246 34.7975C3.22397 35.0294 3.36028 35.2411 3.5336 35.4203C3.70691 35.5996 3.91385 35.7429 4.14258 35.8422C4.37131 35.9415 4.61736 35.9947 4.86667 35.9989H35.2623C35.5116 35.9947 35.7577 35.9415 35.9864 35.8422C36.2151 35.7429 36.4221 35.5996 36.5954 35.4203C36.7687 35.2411 36.905 35.0294 36.9965 34.7975C37.088 34.5655 37.133 34.3178 37.1287 34.0685V10.1999C37.133 9.95061 37.088 9.70291 36.9965 9.47096C36.905 9.23901 36.7687 9.02737 36.5954 8.8481C36.4221 8.66884 36.2151 8.52548 35.9864 8.42621C35.7577 8.32694 35.5116 8.2737 35.2623 8.26953Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39565 16.8008H11.5287V18.9338H9.39565V16.8008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.795 16.8008H17.9281V18.9338H15.795V16.8008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1935 16.8008H24.3265V18.9338H22.1935V16.8008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5929 16.8008H30.7259V18.9338H28.5929V16.8008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39551 22.1367H11.5285V24.2697H9.39551V22.1367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7949 22.1367H17.9279V24.2697H15.7949V22.1367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1934 22.1367H24.3264V24.2697H22.1934V22.1367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5928 22.1367H30.7258V24.2697H28.5928V22.1367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39551 27.4688H11.5285V29.6018H9.39551V27.4688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7949 27.4688H17.9279V29.6018H15.7949V27.4688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1934 27.4688H24.3264V29.6018H22.1934V27.4688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5928 27.4688H30.7258V29.6018H28.5928V27.4688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5304 12.5321C11.8132 12.5321 12.0845 12.4197 12.2845 12.2197C12.4845 12.0197 12.5969 11.7485 12.5969 11.4656V5.06651C12.5969 4.78366 12.4845 4.51238 12.2845 4.31237C12.0845 4.11236 11.8132 4 11.5304 4C11.2475 4 10.9763 4.11236 10.7762 4.31237C10.5762 4.51238 10.4639 4.78366 10.4639 5.06651V11.4656C10.4639 11.7485 10.5762 12.0197 10.7762 12.2197C10.9763 12.4197 11.2475 12.5321 11.5304 12.5321Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5978 12.5321C28.8806 12.5321 29.1519 12.4197 29.3519 12.2197C29.5519 12.0197 29.6643 11.7485 29.6643 11.4656V5.06651C29.6643 4.78366 29.5519 4.51238 29.3519 4.31237C29.1519 4.11236 28.8806 4 28.5978 4C28.3149 4 28.0436 4.11236 27.8436 4.31237C27.6436 4.51238 27.5312 4.78366 27.5312 5.06651V11.4656C27.5312 11.7485 27.6436 12.0197 27.8436 12.2197C28.0436 12.4197 28.3149 12.5321 28.5978 12.5321Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7324 8.26953H25.3976V10.4026H14.7324V8.26953Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_58660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3e1bbe942011e1f92488b37f6e8f5148.svg";
export { ForwardRef as ReactComponent };